import { render, staticRenderFns } from "./TheNote.vue?vue&type=template&id=b01ba1fc&scoped=true&"
import script from "./TheNote.vue?vue&type=script&lang=js&"
export * from "./TheNote.vue?vue&type=script&lang=js&"
import style0 from "./TheNote.vue?vue&type=style&index=0&id=b01ba1fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01ba1fc",
  null
  
)

export default component.exports